<template>
  <hs-layout>
    <h2 class="hs-code__section-heading">{{ $t("Search by section") }}</h2>

    <b-table
      :items="sections"
      :fields="fields"
      class="hs-code__table"
      v-if="!isLoading && !isError"
    >
      <template v-slot:cell(section)="data">{{ data.item.code }}</template>
      <template v-slot:cell(name)="data">
        <router-link
          :to="`/hs-codes/sections/${data.item.code}`"
          class="hs-code__link"
        >
          <div class="hs-code__icon-wrap">
            <font-awesome-icon
              class="hs-code__icon"
              v-if="icons[data.index]"
              :icon="icons[data.index]"
            />
          </div>
          {{ getTitle(data.item) }}
        </router-link>
      </template>
    </b-table>
    <LoadingErrorState
      type="sections"
      :isLoading="isLoading"
      :isError="isError"
    />
  </hs-layout>
</template>

<script>
import LoadingErrorState from "@/components/HSCodes/LoadingErrorState.vue";
import HSLayout from "@/layouts/HSCodes/default.vue";
import icons from "@/data/icons.map.js";
import { getCurrentLanguage } from "@/lang/i18n.js";
import { getTitle } from "@/components/HSCodes/utils.js";
import HSCodeService from "@/services/hs-codes.service";

export default {
  name: "HSCodesIndex",
  data() {
    return {
      language: getCurrentLanguage(),
      fields: [
        { key: "section", label: this.$t("Section") },
        { key: "name", label: this.$t("Name") },
      ],
      icons: icons,
      isError: false,
      isLoading: true,
      sections: [],
    };
  },
  async created() {
    try {
      this.sections = await HSCodeService.section.getAll();
    } catch (e) {
      this.isError = true;
    }

    this.isLoading = false;
  },
  components: {
    LoadingErrorState,
    "hs-layout": HSLayout,
  },
  methods: {
    getTitle,
  },
};
</script>

<style>
.hs-code__section-wrap {
  width: 100%;
  max-width: 750px;
  text-align: left;
  margin-bottom: 30px;
}

.hs-code__icon-wrap {
  width: 20px;
  flex-shrink: 0;
  text-align: center;
  margin-right: 20px;
}

.hs-code__icon {
  margin-top: 3px;
}

.hs-code__table {
  color: #122857 !important;
}

.hs-code__link {
  display: inline-flex;
  color: #122857;
  align-items: flex-start;
  text-decoration: none;
}

.hs-code__loading-icon {
  animation-name: spinner 0.2s;
}
</style>
